import { Platform } from 'react-native';

export const SENTRY_DSN = Platform.select({
  android: process.env.EXPO_PUBLIC_SENTRY_ANDROID_DSN,
  ios: process.env.EXPO_PUBLIC_SENTRY_IOS_DSN,
  web: process.env.EXPO_PUBLIC_SENTRY_WEB_DSN
});

export const ANONYMIZED_VALUE = 'Anonymized';
